import { render, staticRenderFns } from "./LeaguePageGames.vue?vue&type=template&id=6ae6282d&scoped=true&"
import script from "./LeaguePageGames.vue?vue&type=script&lang=js&"
export * from "./LeaguePageGames.vue?vue&type=script&lang=js&"
import style0 from "./LeaguePageGames.vue?vue&type=style&index=0&id=6ae6282d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6282d",
  null
  
)

export default component.exports